// router/index.js
import React from "react";

const routes = [
  {
    path: "/",
    breadcrumb: "不動產服務",
    component: React.lazy(() => import("../views/estate/main"))
  },
  {
    path: "/intro",
    breadcrumb: "歐悅建設介紹",
    component: React.lazy(() => import("../views/estate/main"))
  },
  {
    path: "/privacy-policy",
    breadcrumb: "隱私權保護政策",
    component: React.lazy(() => import("../views/privacy"))
  },
  {
    path: "/terms-use",
    breadcrumb: "使用者規範",
    component: React.lazy(() => import("../views/terms-use"))
  }
];

export default routes;
